import {Box} from 'konva/lib/shapes/Transformer';

export default function boundBoxFunc(oldBox: Box, newBox: Box): Box {
  if (newBox.width < 5 || newBox.height < 5) {
    return oldBox;
  }
  return newBox;
}
